var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var f0 = _vm.item.couponId ? _vm._f("dateFormat")(_vm.item.gmtEnd) : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        f0: f0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }